import { useState } from 'react';

import { AgGridReact } from 'ag-grid-react';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import {
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Dialog as UiDialog,
} from '@/components/ui/dialog';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

import { AddLocationForm } from '../add-location-form';

type AddLocationDialogProps = {
  gridRef?: React.RefObject<AgGridReact>;
  fertilizationSiteId?: string;
  visible: boolean;
  onHide: () => void;
};

export const AddLocationDialog = ({
  gridRef,
  fertilizationSiteId,
  visible,
  onHide,
}: AddLocationDialogProps) => {
  const { t } = useTranslation();
  const isBaseUi = useFeatureFlag('add_location_prime_to_base_ui');
  const [dialogContainer, setDialogContainer] = useState<HTMLElement | null>(
    null,
  );

  if (isBaseUi) {
    return (
      <UiDialog
        open={visible}
        onOpenChange={(open) => {
          if (!open) onHide();
        }}
      >
        <DialogContent
          ref={setDialogContainer}
          preflight={false}
          className="z-[2000] md:max-w-[600px]"
          overlayClassName="z-[2000]"
        >
          <DialogHeader className="preflight">
            <DialogTitle>
              {t('storageLocation.addNewStorageLocation')}
            </DialogTitle>
          </DialogHeader>
          <DialogBody>
            <AddLocationForm
              gridRef={gridRef}
              fertilizationSiteId={fertilizationSiteId}
              popupContainer={dialogContainer ?? undefined}
              onCancel={onHide}
              onSuccess={() => {
                gridRef?.current?.api?.refreshInfiniteCache();
              }}
            />
          </DialogBody>
        </DialogContent>
      </UiDialog>
    );
  }

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t('storageLocation.addNewStorageLocation')}
      modal
      className="w-[600px] max-w-[95vw]"
    >
      <AddLocationForm
        gridRef={gridRef}
        fertilizationSiteId={fertilizationSiteId}
        onCancel={onHide}
        onSuccess={() => {
          gridRef?.current?.api?.refreshInfiniteCache();
        }}
      />
    </Dialog>
  );
};
